import React from 'react';

const Recent = ( props ) => {

    return (
        <g id="path">
            <rect x="18.3" y="4.66" width="2" height="9" rx="0" ry="0"/>
            <rect transform="rotate(-90)" x="-19.3" y="4.66" width="2" height="9" rx="0" ry="0"/>
            <rect transform="rotate(-45)" x="-1" y="12.5" width="2" height="9" rx="0" ry="0"/>
        </g>
    )
};

export default Recent;